import { render, staticRenderFns } from "./AgencyAndProvider.vue?vue&type=template&id=ef2a5e34&"
import script from "./AgencyAndProvider.vue?vue&type=script&lang=js&"
export * from "./AgencyAndProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports